import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { AddLineToWishList, chain } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { dispatchAddToListEvent } from "@store/Services/AnalyticsService";
import { getIsCategoryPage, getIsSearchPage } from "@store/Store/Pages/ProductList/ProductListSelectors";

addToChainAfter(chain, AddLineToWishList, props => {
    if (props.result?.errorMessage) {
        return;
    }
    const state = props.getState();
    const currentPage = getCurrentPage(state);
    const isSearchPage = getIsSearchPage(state);
    const isCategoryPage = getIsCategoryPage(state);
    const currentCurency = state.context.session.currency;
    const products: (ProductContextModel | CartLineModel)[] = props.parameter.productInfos.map(productInfo => {
        const cart = getCurrentCartState(state).value;
        const cartline = cart?.cartLines?.find(cartLine => {
            return cartLine.productId === productInfo.productId;
        });
        if (cartline) {
            return cartline;
        }
        const product = getProductState(state, productInfo.productId).value as ProductModel;
        if (product) {
            const productContext: ProductContextModel = {
                product,
                productInfo: { ...productInfo, productDetailPath: product.canonicalUrl },
            };
            return productContext;
        }
    }) as (ProductContextModel | CartLineModel)[];

    dispatchAddToListEvent(products, 1, currentCurency?.currencyCode, currentPage, isCategoryPage, isSearchPage);
});
